module.exports = __webpack_public_path__ + "quintype-logo-3654a46994d4dd6c1886.png";